import { Observable } from 'rxjs';
import Axios from 'axios-observable';

const Domain = process.env.REACT_APP_ADMIN_API_SERVER;

class Clients {
    get() {
        return new Observable(subscriber => {
            Axios.get(Domain + '/clients/?page=1&per_page=100').subscribe(resp => {
                subscriber.next(resp.data.clients);
                subscriber.complete();
            });
        })
    }
}
export default new Clients();